class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/renew`;
    }
    /**
     * Renews the existing webinar subscription.
     * HTTP Method: post
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}/renew
     * Rate Limit Group: Light
     */
    async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
